<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2">{{ title }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <h6 class="text-uppercase" i18n>DRB Item Details</h6>
    <dl class="row small">
      <dt class="col-2" i18n>ID</dt>
      <dd class="col-10">{{ sourceItem.id }}</dd>
      <dt class="col-2" i18n>Location</dt>
      <dd class="col-10">{{ sourceItem.location }}</dd>
      <dt class="col-2" i18n>Created by</dt>
      <dd class="col-10">{{ sourceItem.created_by }}</dd>
      <dt class="col-2" i18n>Created on</dt>
      <dd class="col-10">{{ utility.convertUnixTime_global(sourceItem.created_ts) }}</dd>
      <dt class="col-2" i18n>Last updated by</dt>
      <dd class="col-10">{{ sourceItem.last_updated_by }}</dd>
      <dt class="col-2" i18n>Last updated on</dt>
      <dd class="col-10">{{ utility.convertUnixTime_global(sourceItem.last_updated_ts) }}</dd>
    </dl>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="info" (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
